namespace SP {

    
    export async function post<T>(postUrl: string, data: any, callback: (result: any) => any = null) {
        const response = await fetch(postUrl, {
            method: 'POST',
            cache: "no-store",
            headers: {
                'Accept': 'application/json, text/plain, */*',
                'Content-Type': 'application/json',
                'pragma': 'no-cache',
                'cache-control': 'no-store',
                'Smartpack-Request-Id': (crypto as any).randomUUID()
            },
            body: JSON.stringify(data)
        });

        if (!response.ok) {
            //await SP.alertX("error posting, check console!");
            console.log(response);
            //console.log((await response.text()));
        }

        var result = await response.json();

        if (callback != null)
            callback(result);

        return SP.promise<T>(result);
    }
}